const rankingItems = [
  { rank: 1, title: '暗潮', type: '电影', rating: '8.7', trend: 'up', hot: true },
  { rank: 2, title: '山河纪 第三季', type: '电视剧', rating: '9.1', trend: 'up', hot: true },
  { rank: 3, title: '星际迷航：新纪元', type: '电影', rating: '8.4', trend: 'new', hot: true },
  { rank: 4, title: '青春不散场', type: '电影', rating: '7.9', trend: 'up', hot: false },
  { rank: 5, title: '深海迷踪', type: '纪录', rating: '9.3', trend: 'up', hot: false },
  { rank: 6, title: '极限追逐', type: '电影', rating: '7.6', trend: 'down', hot: false },
  { rank: 7, title: '都市夜话', type: '电视剧', rating: '8.1', trend: 'new', hot: false },
];

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  new: 'ri-flashlight-line',
};

const trendColors: Record<string, string> = {
  up: 'text-accent-400',
  down: 'text-foreground-500',
  new: 'text-secondary-400',
};

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-400">实时热度排名，发现大家都在看什么</p>
        </div>

        <div className="bg-background-200/30 rounded-lg border border-background-300/20 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 px-5 py-4 border-b border-background-300/20 last:border-b-0 cursor-pointer hover:bg-background-200/40 transition-colors ${
                item.hot ? 'bg-primary-500/5' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm shrink-0 ${
                item.rank <= 3
                  ? 'bg-accent-500 text-background-50'
                  : 'bg-background-300/30 text-foreground-300'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-200 whitespace-nowrap">
                    {item.title}
                  </span>
                  {item.hot && (
                    <span className="inline-flex items-center gap-0.5 text-xs text-accent-400">
                      <i className="ri-fire-line"></i>
                    </span>
                  )}
                </div>
                <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <span className={`text-xs flex items-center gap-0.5 ${trendColors[item.trend]}`}>
                  <i className={trendIcons[item.trend]}></i>
                </span>
                <span className="text-sm font-heading font-bold text-primary-400">{item.rating}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}